import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Clock } from "lucide-react";

export default function GuideArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setArticle(null); setError("");
    api.get(`/guide/${slug}`).then((r) => setArticle(r.data)).catch(() => setError("Article not found"));
  }, [slug]);

  if (error) {
    return (
      <div className="max-w-2xl">
        <Link to="/app/guide" className="text-stone-500 hover:text-stone-900 inline-flex items-center gap-1 text-sm mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to guide
        </Link>
        <p className="text-stone-500" data-testid="guide-article-error">{error}</p>
      </div>
    );
  }
  if (!article) return <p className="text-stone-500">Loading…</p>;

  return (
    <article className="max-w-3xl" data-testid={`guide-article-${article.slug}`}>
      <Link to="/app/guide" className="text-stone-500 hover:text-stone-900 inline-flex items-center gap-1 text-sm">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to guide
      </Link>
      <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-semibold mt-6">{article.level}</div>
      <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight mt-2">{article.title}</h1>
      <div className="flex items-center gap-3 mt-3 text-sm text-stone-500">
        <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {article.reading_minutes} min read</span>
      </div>
      {article.summary && <p className="text-lg text-stone-700 mt-5 leading-relaxed border-l-4 border-amber-300 pl-4 italic">{article.summary}</p>}

      {article.hero_image && (
        <img src={article.hero_image} alt="" className="w-full rounded-2xl mt-6 border border-stone-200" />
      )}

      <div
        className="prose prose-stone prose-img:rounded-lg prose-a:text-amber-700 mt-8 max-w-none"
        data-testid="guide-article-body"
        // body is sanitized server-side (shared.html_sanitize) against a tight allow-list
        dangerouslySetInnerHTML={{ __html: article.body || "" }}
      />
    </article>
  );
}
